import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { DataProvider } from '@atlassian/jira-providers-issue/src/model/data-provider.tsx';
import { IssueKeysCache } from './issue-keys-cache.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (dataProvider: DataProvider, issueElementSelector: string, issueDataKey: string) => {
	const navigatorIssueKeysCache = new IssueKeysCache(50);

	const fetchIssues = (issueKeys: Array<string>) => {
		dataProvider.loadIssues(issueKeys);
	};

	const visibleIssueKeys$ = new Subject();
	// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string[]'.
	visibleIssueKeys$.debounceTime(1000).subscribe((keys) => fetchIssues(keys));

	const handleIntersect = (entries: Array<IntersectionObserverEntry>) => {
		entries.forEach((entry) => {
			const navigatorIssueKey = entry.target.getAttribute(issueDataKey);
			if (!navigatorIssueKey) return;

			if (entry.isIntersecting) {
				navigatorIssueKeysCache.push(navigatorIssueKey);
			} else {
				navigatorIssueKeysCache.remove(navigatorIssueKey);
			}
		});

		if (navigatorIssueKeysCache.hasNewKeyAdded()) {
			visibleIssueKeys$.next(navigatorIssueKeysCache.getIssueKeysAndMarkRead());
		}
	};

	const setupObserver = () => {
		const options = {
			root: null,
			rootMargin: '0px',
			threshold: [0, 1],
		};

		const observer = new IntersectionObserver(handleIntersect, options);

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (window.AJS) {
			// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'e' implicitly has an 'any' type.

			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.AJS.$(issueElementSelector).each((_, e) => observer.observe(e));
		} else {
			log.safeWarnWithoutCustomerData(
				'issue.intersection.cache',
				'window.AJS not ready when initialization of observer attempted',
			);
		}
	};

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (!window.IntersectionObserver) {
		// IE or browser doesn't support IntersectionObserver, so we reset cache to avoid staled data from showing.
		// And we don't need to setup Observer either.
		dataProvider.clearCache();
	} else {
		setupObserver();
	}
};
